import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.LOCATIONS_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.LOCATIONS_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.LOCATIONS_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.LOCATIONS_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.LOCATIONS_FILTER_BY, filterBy)
  },
  [types.SET_NETWORK_TREE](state, data) {
    state.networkTree = data
  },
  [types.SET_LOCATION_TREE](state, data) {
    state.locationTree = data
  },
  [types.SET_LOCATIONS](state, data) {
    state.locations = data
  },
  [types.SET_FOUND_LOCATIONS](state, data) {
    state.foundLocations = data
  },
  [types.SET_LOCATION](state, data) {
    state.location = data
  },
  [types.PUSH_LOCATION](state, data) {
    state.locationTree.push(data)
    state.currentLocation = state.locationTree.slice(-1)[0]
  },
  [types.POP_LOCATION](state) {
    state.locationTree.pop()
    state.currentLocation = state.locationTree.slice(-1)[0]
  },
  [types.SET_LOCATIONS_FOUND](state, data) {
    state.locationsFound = []
    if (data !== undefined && data !== null) {
      state.locationsFound = data
    }
  },
  [types.RESET_PREFERENCE_CHANGE](state, element) {
    if (state.preferences !== undefined && state.preferences !== null) {
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          if (state.preferences[i] !== '') {
            state.preferences[i].changed = false
          }
        }
      }
    }
  },
  [types.RESET_ADD_LOCATION](state) {
    state.addLocation = JSON.parse(JSON.stringify(state.defaultLocation))
  },
  [types.SET_ADD_LOCATION](state, data) {
    state.addLocation[data.name] = data.value
  },
  [types.RESET_PREFERENCES](state) {
    state.preferences = []
  },
  [types.RESET_PRICING](state) {
    state.calibrationPricing = []
  },
  [types.UPDATE_PREFERENCE](state, data) {
    if (state.preferences.length === 0) {
      state.preferences = []
    }
    if (state.preferences !== undefined && state.preferences !== null) {
      let found = false
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          if (state.preferences[i].name === data.name) {
            state.preferences[i].value = data.value
            state.preferences[i].changed = true
            state.preferences[i].firm = data.firm
            found = true
            break
          }
        }
      }
      if (found === false) {
        data.changed = true
        state.preferences.push(data)
      }
    }
    console.log('Update Preference', state.preferences)
  },
  [types.SET_PREFERENCES](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        if (Array.isArray(data)) {
          data.forEach((element) => {
            element.changed = false
          })
        }
      }
    }
    state.preferences = state.preferences.concat(data)
    console.log('Got Preferences', state.preferences)
  },
  [types.SET_INSURANCE_DATA](state, data) {
    switch (data.name) {
      case 'optIn':
        let found = state.insurance.find((x) => x.firm2 === data.value)
        console.log('Set Insurance Data', {
          insurance: state.insurance,
          found: found
        })
        if (found) {
          found.isOptIn = !found.isOptIn
        }
        break
    }
  },
  [types.SET_INSURANCE_FOUND](state, data) {
    state.insuranceFound = data
  },
  [types.SET_INSURANCE](state, data) {
    state.insurance = data
  },
  [types.PUSH_INSURANCE](state, data) {
    let found = state.insurance.find((x) => parseInt(x.firm2) === parseInt(data.firm2))
    if (!found) {
      state.insurance.push(data)
    }
  },
  [types.POP_INSURANCE](state, id) {
    let found = state.insurance.find((x) => parseInt(x.firm2) === parseInt(id))
    if (found) {
      if (found.isAdd) {
        state.insurance = state.insurance.filter((x) => parseInt(x.firm2) !== parseInt(id))
      } else {
        found.isRemove = true
      }
    }
  },
  [types.SET_PROVIDER_DATA](state, data) {
    switch (data.name) {
      case 'optIn':
        let found = state.providers.find((x) => x.firm2 === data.value)
        console.log('Set Provider Data', found)
        if (found) {
          found.isOptIn = !found.isOptIn
        }
        break
    }
  },
  [types.RESET_SEARCH](state) {
    state.providerFound = []
  },
  [types.SET_PROVIDER_FOUND](state, data) {
    state.providerFound = data
    state.providerFound.forEach((element) => {
      if (state.providers.length > 0) {
        let found = state.providers.find((x) => parseInt(x.firm2) === parseInt(element.firm))
        if (found) {
          element.isOptIn = found.isOptIn
        }
      }
    })
    console.log('Set Provider Found', {
      foundProviders: state.providerFound,
      providers: state.providers
    })
  },
  [types.SET_FOUNDPROVIDER_DATA](state, data) {
    switch (data.name) {
      case 'isOptIn':
        let found = state.providerFound.find((x) => parseInt(x.firm) === parseInt(data.value))
        if (found) {
          found.isRemove = false
          found.isOptIn = !found.isOptIn
          if (!found.isOptIn) {
            found.isRemove = true
          }
          let found2 = state.providers.find((x) => parseInt(x.firm2) === parseInt(found.firm))
          if (found2) {
            found2.isOptIn = found.isOptIn
            found2.isRemove = found.isRemove
          }
        }
        break
      case 'allOptIn':
        state.providerFound.forEach((element) => {
          element.isOptIn = data.value
          element.isRemove = !data.value
          let found2 = state.providers.find((x) => parseInt(x.firm2) === parseInt(element.firm))
          if (found2) {
            found2.isOptIn = data.value
            found2.isRemove = !data.value
          }
        })
        break
    }
    console.log('Set Found Provider Data', {
      foundProviders: state.providerFound,
      providers: state.providers
    })
  },
  [types.RESET_PROVIDERS](state) {
    state.providers = []
  },
  [types.SET_PROVIDERS](state, data) {
    state.providerFound = []
    if (data) {
      data.forEach((element) => {
        element.firmName2 = element.firmName
        element.firmName = null
        state.providerFound.push({
          firm: element.firm2,
          name: element.firmName2,
          license: element.license,
          postalCode: element.postalCode,
          isOptIn: element.isOptIn,
          relationship: element.relationship,
          firmClass: element.firmClass,
          isMCP: element.isMCP
        })
      })
    }
    state.providers = data
  },
  [types.PUSH_PROVIDER](state, data) {
    let found = state.providers.find((x) => parseInt(x.firm2) === parseInt(data.firm2))
    if (found) {
      found.isRemove = false
      found.isAdd = false
      found.isOptIn = data.isOptIn
      if (!data.isOptIn) {
        found.isRemove = true
      }
    } else {
      state.providers.push(data)
    }
  },
  [types.POP_PROVIDER](state, id) {
    let found = state.providers.find((x) => parseInt(x.firm2) === parseInt(id))
    if (found) {
      if (found.isAdd) {
        state.providers = state.providers.filter((x) => parseInt(x.firm2) !== parseInt(id))
      } else {
        found.isRemove = true
        found.isOptIn = false
      }
    }
  },
  [types.SET_PRICING](state, data) {
    state.calibrationPricing = data
  },
  [types.SET_PROVIDER_PROFILE](state, data) {
    state.providerProfile = data
  },
  [types.SET_PROVIDER_REVIEWS](state, data) {
    state.providerReviews = data
  },
  [types.RESET_PROVIDER_PROFILE](state) {
    state.providerProfile = null
    state.providerReviews = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/mutations.js